<script>
import { Bar } from 'vue-chartjs'

Chart.Tooltip.positioners.center = function (elements) {
  const {x, y, base} = elements[0]._model;
  const height = base - y;
  return {x, y: y + (height / 2)};
};

export default {
  extends: Bar,
  props: ['dataProp', 'maxValue'],
  data() {
    return {
      options: {
        hover: {
          animationDuration: 0
        },
        tooltips: {
          position: 'center',
          caretPadding: 25,
          backgroundColor: 'rgba(0,0,0,1)',
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';
              var value = tooltipItem.yLabel;

              if (label) {
                label += ': ';
              }
              label += value;
              return label;
            }
          }
        },
        animation: {
          duration: 1000
        },
        scales: {
          yAxes: [{
            position: 'right',
            padding: 50,
            type: 'linear', // Changed from 'logarithmic' to 'linear'
            ticks: {
              autoSkip: true,
              beginAtZero: true,
              fontColor: '#414141',
              display: true,
              drawBorder: true,
              suggestedMax: this.maxValue, // Ensure this is set to an appropriate max value
              min: 0,
              callback: function (value, index, values) {
                if (value % 2 === 1 || value % 2 === 0) {
                  return value; // Simplified callback for linear scale
                }
              }
            },
            gridLines: {
              drawBorder: false,
              display: true,
              drawTicks: false
            }
          }],
          xAxes: [{
            maxBarThickness: 80,
            ticks: {
              beginAtZero: true,
              reverse: false,
            },
            gridLines: {
              drawBorder: true,
              display: false
            }
          }]
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 2,
            bottom: 0
          }
        },
        drawBorder: true,
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },

  watch: {
    dataProp: function (newVal, oldVal) {
      this.$data._chart.destroy();
      this.renderChart(newVal, this.options);
    }
  },

  computed: {
    dataset: function () {
      return this.dataProp;
    }
  },

  mounted() {
    if (this.options) {
      this.options.scales.yAxes[0].ticks.suggestedMax = this.maxValue;
    }
    this.renderChart(
        this.dataset,
        this.options
    );
  }
}
</script>
